import { AdhesionPaymentInterface } from '../../../../interfaces/dto/sales-portal/adhesion-payment/adhesion-payment-interface';
import { AdhesionBankingInformationModel } from '@fh-client-interaction-frontends/fh-data-access-adhesion';

export class AdhesionPaymentModel implements AdhesionPaymentInterface {
  paymentMethod: string = '';
  firstPaymentMethod: string = '';
  fractioning: string = '';
  crmId: string = "";
  bankingInformation?: AdhesionBankingInformationModel;

  constructor(init?: Partial<AdhesionPaymentModel>) {
    Object.assign(this, init);
  }
}
